import Vue from 'vue'
import VueAxios from 'vue-axios'
import JWT from './jwt'
import axios from 'axios'
import { API_URL } from '../../config/HTTP'
import Cookies from 'js-cookie'

const Api = {
  init() {
    setInterval(() => {
      const token = localStorage.getItem('token')
      if (token !== JWT.getToken()) {
        this.$router.push({ name: 'login' })
      }
    }, 1000)
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = API_URL
    Vue.axios.defaults.headers['Cache-Control'] = 'no-cache'
    Vue.axios.defaults.headers['Pragma'] = 'no-cache'
    Vue.axios.defaults.headers['Expires'] = '0'
    if (JWT.getToken()) {
      this.addAuthorizationHeader()
      Cookies.set('Authorization', JWT.getToken())
    } else {
      this.removeAuthorizationHeader
    }
    this.checkToken()
  },
  async checkToken() {
    try {
      const res = await axios.get(`${API_URL}/Idp/Profile`)
    } catch (error) {
      if (error.response.status === 401) {
        JWT.deleteToken()
        this.$router.push({ name: 'login' })
      }
    }
  },
  removeAuthorizationHeader() {
    delete axios.defaults.headers.common['Authorization']
  },
  addAuthorizationHeader() {
    Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${JWT.getToken()}`
    Vue.axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate'
    Vue.axios.defaults.headers.common['Pragma'] = 'no-cache'
    Vue.axios.defaults.headers.common['Expires'] = 0
  },

  query(resource, params) {
    return Vue.axios.get(resource, params)
  },

  get(resource) {
    return Vue.axios.get(`${resource}`)
  },

  post(resource, params, config) {
    return Vue.axios.post(`${resource}`, params, config)
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params)
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params)
  },

  delete(resource, params) {
    return Vue.axios.delete(resource, params)
  },
}

export default Api
